import { AttributeValue, AttributeTextValue, AttributeValueBase } from '@msdyn365-commerce/retail-proxy';
import { getAttributeValuesAsync } from '@msdyn365-commerce/retail-proxy/dist/DataActions/ProductsDataActions.g';
import { QueryResultSettingsProxy } from '@msdyn365-commerce-modules/retail-actions';
import { IActionContext } from '@msdyn365-commerce/core';

export const createTextAttribute = (name: string, value: string) => ({
    Name: name,
    TextValue: value,
    TextValueTranslations: [],
    '@odata.type': '#Microsoft.Dynamics.Commerce.Runtime.DataModel.AttributeTextValue'
});

export const updateTextAttribute = (attribute: AttributeTextValue, value: string) => {
    if (attribute) {
        attribute.TextValue = value;
        attribute.TextValueTranslations = [];
        //@ts-ignore
        attribute['@odata.type'] = '#Microsoft.Dynamics.Commerce.Runtime.DataModel.AttributeTextValue';
    }

    return attribute;
};

export const addOrUpdateTextAttribute = (attributes: AttributeValueBase[], attributeName: string, value: string): AttributeValueBase[] => {
    const existingAttribute = getAttributeByName(attributeName, attributes);

    if (existingAttribute) {
        updateTextAttribute(existingAttribute as AttributeTextValue, value);
    } else {
        attributes?.push(createTextAttribute(attributeName, value));
    }

    return attributes;
};

export const getAttributeByName = (attributeName: string, attributes: AttributeValueBase[]): AttributeValueBase | undefined => {
    const attribute = attributes?.find(({ Name }) => Name === attributeName);

    return attribute;
};

export const getAttributeTextValueByName = (attributeName: string, attributes: AttributeValueBase[]): string => {
    const attribute = getAttributeByName(attributeName, attributes);
    const value = (attribute as AttributeTextValue)?.TextValue;

    return value ?? '';
};

export const getProductsAttributes = async (
    productIds: number[],
    catalogId: number,
    channelId: number,
    actionContext: IActionContext
): Promise<Map<number, AttributeValue[]>> => {
    const qrs = QueryResultSettingsProxy.getPagingFromInputDataOrDefaultValue(actionContext);
    const map: Map<number, AttributeValue[]> = new Map();

    await Promise.all(
        productIds.map(async id => {
            try {
                const attrs = await getAttributeValuesAsync(
                    { callerContext: actionContext, queryResultSettings: qrs },
                    id,
                    channelId,
                    catalogId
                );
                map.set(id, attrs);
            } catch {
                map.set(id, []);
            }
        })
    );

    return map;
};
